import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const authService = {
    onLogin: (request) =>
        serviceInstance
            .post(`${config.baseurl}auth/initiate-login-otp `, request)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),
    login: (request) =>
        serviceInstance
            .post(`${config.baseurl}login `, request)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),

    getProfile: () =>
        serviceInstance
            .get(`${config.baseurl}api/v1/profile`)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),
    joinlist: (data) =>
        serviceInstance
            .post(`${config.baseurl}api/v1/wait-list`, data)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),


    submitKyc: (data) =>
        serviceInstance
            .post(`${config.baseurl}api/v1/kyc/submit`, data)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),

    verifyPhone: (data) =>
        serviceInstance
            .post(`${config.baseurl}auth/verify-phone-number`, data)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),

    register: (data) =>
        serviceInstance
            .post(`${config.baseurl}auth/sign-up`, data)
            .then(({ data, status }) => ({
                ...data,
                status,
            })),



    logout: (request) =>
        serviceInstance
            .post(`${config.baseurl}/Account/Logout`, {})
            .then(({ data, status }) => ({
                ...data,
                status,
            })),
};

export default authService;